// Hardcoded currency temporary
export const withCurrency = (n: any) => {
  return n || typeof n === "number" ? "£ " + n : "-";
};
